import './_control-block.sass';

import React from 'react';
import * as classnames from 'classnames';
import {connect} from 'react-redux';

import '../../../../../../mui/_dialog.sass';

import './contextmenu.css';
import {ControlButton} from './control-button';
import {createSubsetSelector} from '../../../../../../utils';
import {sendCustomCommand} from '../../../../../redux/devices/items/actions';
import {MessageBox} from '../../../../../dialogs/dialogs';
import {selectDevice} from '../../../../../entities/device/lib';

const vibrate = () => navigator.vibrate?.(400);
class CustomControlButton extends React.Component {
    constructor(props) {
        super(...arguments);
        this.state = {
            slow_fade: false,
            checkmark_shown: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loading && !this.props.loading) {
            this.setState({slow_fade: true, checkmark_shown: true});
            setTimeout(() => this.setState({checkmark_shown: false}), 50);
            setTimeout(() => this.setState({slow_fade: false}), 4000);
        }
    }

    render() {
        const {
            contextmenuid,
            status_value,
            loading,
            config,
            online,
            can_control,
            onSendCommand,
            onDisabledClick,
        } = this.props;

        const status = config.statuses?.[0] || null;
        const default_command = (() => {
            if (!(config.commands?.length > 0)) return null;

            if (status != null) {
                for (const cmd of config.commands) {
                    if (cmd.active_if_status === status_value) {
                        return cmd;
                    }
                }
            }

            return config.commands[0];
        })();

        let label;
        if (status?.name && status.title_if_status?.[status_value])
            label = `${status.name} ${status.title_if_status?.[status_value]}`;
        else if (status?.name) label = status.name;
        else if (status?.title_if_status?.[status_value])
            label = status.title_if_status?.[status_value];
        else if (default_command != null) label = default_command.name;
        else label = '[некорректный дескриптор]';

        let active;
        if (loading && status == null) active = true;
        else if (status?.active_value != null)
            active = status_value === status.active_value;
        else if (status_value != null) active = !!status_value;
        else active = false;

        return (
            <ControlButton
                addClass={classnames('ui-custom-control-button', {
                    'ui-custom-control-button-clickable': default_command != null,
                    'ui-custom-control-slow-fade': this.state.slow_fade,
                    'ui-custom-control-button-checkmark-shown':
                        this.state.checkmark_shown,
                })}
                square={false}
                loading={loading}
                disabled={!online || !can_control}
                label={label}
                active={active}
                contextmenuid={contextmenuid}
                contextmenu={(config.commands || []).map((cmd) => ({
                    title: cmd.name,
                    action: () => onSendCommand(cmd.id),
                    default: cmd == default_command,
                }))}
                has_menu={(config.commands || []).length > 0}
                onClick={() => {
                    if (default_command != null) onSendCommand(default_command?.id);
                }}
                onDisabledClick={onDisabledClick}
            >
                <span
                    className={classnames(
                        'ui-custom-control-button-checkmark',
                        'ui-icon-custom-controls-checkmark'
                    )}
                />
            </ControlButton>
        );
    }
}

class CustomControlsBlockImpl extends React.Component {
    constructor(props) {
        super(...arguments);

        this.state = {
            offline_dialog_open: false,
            cant_control_dialog_open: false,
        };

        this.hide_offline_dialog = this.hide_offline_dialog.bind(this);
        this.hide_cant_control_dialog = this.hide_cant_control_dialog.bind(this);
        this.onDisabledClick = this.onDisabledClick.bind(this);
    }

    hide_offline_dialog() {
        this.setState({offline_dialog_open: false});
    }
    hide_cant_control_dialog() {
        this.setState({cant_control_dialog_open: false});
    }

    onDisabledClick() {
        if (this.props.can_control) this.setState({offline_dialog_open: true});
        else this.setState({cant_control_dialog_open: true});
    }

    render() {
        const {r_device, onSendCustomCommand} = this.props;

        return (
            <div className="ui-custom-controls-block">
                {(r_device.custom_controls || []).map((config, i) => (
                    <CustomControlButton
                        key={i}
                        contextmenuid={'CustomControlButton' + i}
                        config={config}
                        status_value={
                            r_device.custom_controls_state?.[config?.statuses?.[0]?.id]
                        }
                        loading={r_device.custom_controls_elements__loading?.[i]}
                        fail={r_device.custom_controls_elements__fail?.[i]}
                        online={r_device.online}
                        can_control={this.props.can_control}
                        onSendCommand={(command_id) =>
                            onSendCustomCommand(r_device.id, i, command_id)
                        }
                        onDisabledClick={this.onDisabledClick}
                    />
                ))}

                <MessageBox
                    open={this.state.offline_dialog_open}
                    isError
                    onClose={this.hide_offline_dialog}
                    title="Устройство не на связи"
                >
                    <p>Управление доступно только когда есть связь с устройством</p>
                </MessageBox>

                <MessageBox
                    open={this.state.cant_control_dialog_open}
                    isError
                    onClose={this.hide_cant_control_dialog}
                    title="Нет доступа"
                >
                    <p>У вас недостаточно прав для управления этим устройством</p>
                </MessageBox>
            </div>
        );
    }
}

const CustomControlsBlock_device_selector = createSubsetSelector([
    'id',
    'online',
    'custom_controls',
    'custom_controls_state',
    'custom_controls_elements__loading',
    'custom_controls_elements__fail',
]);

export var CustomControlsBlock = connect(
    (state, {device_id}) => ({
        r_device: CustomControlsBlock_device_selector(selectDevice(state, device_id)),
    }),

    (dispatch) => ({
        onSendCustomCommand: (device_id, element_no, command_id) => {
            vibrate();
            dispatch(sendCustomCommand(device_id, element_no, command_id));
        },
    })
)(CustomControlsBlockImpl);
